import { Stack, StackProps, styled } from "@mui/material";
import {
  GreenButton,
  LoadingSkeleton,
  Row,
  SmText,
  SmTextMd,
  TextMd,
  TimeDiff,
  XsText,
} from "Components";
import { memo, useEffect, useMemo, useState, Fragment } from "react";
import { scrollToElement } from "helpers/browser";
import useGetData from "hooks/useGetData";
import { apiGetCompanyDetail } from "services/api/company";
import { SendMessageButton } from "Components/button/index";
import { Link } from "Components/link";
import { DIRECT_PATHS } from "constants/routes";
import { COLORS } from "constants/layout";
import dayjs from "dayjs";
// import { SmEmailIcon, SmLockIcon, SmPhoneIcon } from "Assets/icons";
import { useTranslation } from "hooks/useTranslation";
// import useAuth from "hooks/useAuth";
import UserAvatar from "Components/avatar/UserAvatar";
import { useLocation } from "react-router-dom";
// import Tooltip from "Components/tooltip/Tooltip";

const PaidContactSupplier = (props: StackProps & { supplierId?: string }) => {
  const { supplierId, ...rest } = props;
  const t = useTranslation();
  const NOW = dayjs();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  // const { onDirectLogin, isLoggedIn } = useAuth();

  const { data, isLoading } = useGetData({
    promise: () => (supplierId ? apiGetCompanyDetail(supplierId) : null),
    deps: [supplierId],
  });

  const supplierDetail = useMemo(() => data?.data?.farm || {}, [data]);

  const {
    last_active,
    name,
    farm_avatar,
    salutation,
    position,
    farmer_name,
    user_image,
    // farm_phone = "",
    // email,
  } = supplierDetail || {};

  // const infors = useMemo(() => {
  //   return [
  //     {
  //       icon: SmPhoneIcon,
  //       value: farm_phone,
  //       label: "phone",
  //     },
  //     {
  //       icon: SmEmailIcon,
  //       value: email,
  //       label: "email",
  //     },
  //   ].filter((infor) => infor.value);
  // }, [farm_phone, email]);

  // const onClickLockIcon = () => {
  //   onDirectLogin();
  // };
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  useEffect(() => {
    if (document.readyState === "complete") {
      setIsPageLoaded(true);
    } else {
      window.addEventListener("load", () => setIsPageLoaded(true));
    }
  }, []);

  useEffect(() => {
    const isScroll = queryParams.get("isScroll") === "true";
    if (isScroll && isPageLoaded ) {
      setTimeout(() => {
        scrollToElement("inquiry-form");
      }, 1000);
    }
  }
  , [queryParams, isPageLoaded]);

  return (
    <StyledContactSupplier spacing={1} {...rest}>
      <TextMd component="h2">{t("contact_supplier_2")}</TextMd>

      {isLoading && <LoadingSkeleton alignItems="flex-start" />}
      {!isLoading && (
        <Fragment>
          <Row spacing={1}>
            <UserAvatar data={{ salutation, user_image }} />
            <Stack
              spacing={0.5}
              flex={1}
              maxWidth={`calc(100% - ${farm_avatar ? "48px" : "0px"})`}
            >
              {farmer_name && (
                <Link to={DIRECT_PATHS.supplierDetail(name)}>
                  <SmTextMd className="company_name ellipsis-text">
                    {salutation ? `${salutation}. ` : ""}
                    {farmer_name}
                  </SmTextMd>
                </Link>
              )}
              {position && <XsText color={COLORS.gray[600]}>{position}</XsText>}
            </Stack>
          </Row>

          {last_active && (
            <SmText className="active-text" color={COLORS.gray[600]}>
              {t("active_value_ago", {
                value: (
                  <TimeDiff
                    endTime={NOW.format()}
                    startTime={dayjs(last_active).format()}
                  />
                ),
              })}
            </SmText>
          )}

          {/* {infors.map(({ value, icon: Icon, label }, i) => {
            return (
              <Row key={i} spacing={1}>
                <Icon className="label" />
                <Row spacing={1} flex={1}>
                  <SmText className="value" color={COLORS.gray[500]}>
                    {t(label)}:{" "}
                    <span style={{ color: COLORS.green[600] }}>{value}</span>
                  </SmText>
                  {!isLoggedIn && (
                    <Tooltip title={t("login_to_view_supplier_contact")}>
                      <span className="lock-icon" onClick={onClickLockIcon}>
                        <SmLockIcon width={10} height={10} />
                      </span>
                    </Tooltip>
                  )}
                </Row>
              </Row>
            );
          })} */}

          <Stack
            spacing={1}
            direction="row"
            justifyContent={{ xs: "center", md: "flex-start" }}
          >
            <GreenButton onClick={() => scrollToElement("inquiry-form")}>
              {t("inquiry_now")}
            </GreenButton>
            <SendMessageButton identity={supplierDetail?.identity} />
          </Stack>
        </Fragment>
      )}
    </StyledContactSupplier>
  );
};

const StyledContactSupplier = styled(Stack)({
  fontSize: 16,
  ".get_card_button": {
    "&.Mui-disabled": {
      opacity: 0.6,
    },
  },
  ".actions > *": {
    flex: 1,
    padding: "6px 12px",
    minHeight: 48,
  },
  ".lock-icon": {
    width: 20,
    height: 20,
    backgroundColor: COLORS.gray[50],
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
});

export default memo(PaidContactSupplier);
